var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color && _vm.precoloredSrc)?_c('g',[_c('image',{attrs:{"width":"800","height":"1000","xlink:href":_vm.precoloredSrc}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }